import React from "react";
import Firebase from "firebase/app";
import {useAuthState} from "react-firebase-hooks/auth";
import Employee from "../../../Models/Employee";
import useFavorites from "../../../Context/Consumers/useFavorites";
import toggleFavorite from "../../../Helper/toggleFavorite";
import ItemType from "../../../Models/ItemType";
import triggerHaptics from "../../../Helper/triggerHaptics";
import useBuildings from "../../../Context/Consumers/useBuildings";
import EmployeePage from "./EmployeePage";
import EmployeePageHeader from "./EmployeePageHeader";
import EmployeePageBody from "./EmployeePageBody";
import EmployeePageFooter from "./EmployeePageFooter";
import Building from "../../../Models/Building";

interface EmployeeModalProps {
    open: boolean;
    dismiss: () => void;
    employee: Employee;
}

export const EmployeeModal = (props: EmployeeModalProps) => {
    const {open, dismiss, employee} = props;
    const [user] = useAuthState(Firebase.auth());
    const favorites: any = useFavorites();
    const buildings = useBuildings();

    const onClickFavorite = () => {
        toggleFavorite(employee.id, ItemType.Employee, favorites, user.uid);
        triggerHaptics();
    };

    const getBuilding = (employee: Employee, buildings: Building[] = []): Building | null => {
        if (employee && employee.location) {
            let buildingCode = employee.location.split(' ')[0]

            return buildings.filter(
                (currentBuilding) => buildingCode == currentBuilding.code
            )[0];
        }

        return null;
    }

    return (
        <EmployeePage
            open={open}
            dismiss={dismiss}
            >
            <EmployeePageHeader
                title={"Profile"}
                />
            <EmployeePageBody
                employee={employee}
                building={getBuilding(employee, buildings)}
                />
            <EmployeePageFooter
                employee={employee}
                dismiss={dismiss}
                user={user}
                onClickFavorite={onClickFavorite}
            />
        </EmployeePage>
    );
};

export default EmployeeModal

